import React, { useState } from 'react';
import Navbar from './Navbar';
import Footer from './LandingFooter';
import CarouselSection from './HomePage/Carousel';
import FirstSection from './HomePage/FirstSection';
import SecondSection from './HomePage/SecondSection';
import CardOne from './HomePage/CardOne';
import CardTwo from './HomePage/CardTwo';
import CardThree from './HomePage/CardThree';
import { Grid } from '@mui/material';
import QRCode from 'react-qr-code';
import { sendMessage, startWhatsApp } from 'app/api-ws/whatsapp-ws';
const LandingScreen = () => {
  // const [qrData, setQrData] = useState('');
  // const connectWhatsapp = () => {
  //   startWhatsApp()
  //     .then((res) => {
  //       console.log(res);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };

  // const sendWhatsappMessage = () => {
  //   const whatsappRequest = {
  //     number: '918073270463',
  //     message: 'Hi giddus'
  //   };
  //   sendMessage(whatsappRequest)
  //     .then((res) => {
  //       console.log(res);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };
  return (
    <div>
      <Navbar />
      <CarouselSection />
      {/* <div>
        <button onClick={connectWhatsapp}>connect to whatsapp</button>
        <button onClick={sendWhatsappMessage}>Send sms</button>
        <QRCode value={qrData} />
      </div> */}
      <Grid container direction="column">
        <FirstSection />

        <SecondSection />

        <CardOne />
        <CardTwo />
        <CardThree />
      </Grid>
      <Footer />
    </div>
  );
};

export default LandingScreen;
